import React from 'react';

import { Box, Hidden, Icon, Typography, Visible } from '@vp/swan';

export interface PersonalizationCardErrorProps {
  message: string;
}

export const PersonalizationCardError: React.FC<PersonalizationCardErrorProps> = ({ message }) => {
  return (
    <Box display="flex" marginTop="3" style={{ alignItems: 'flex-start' }}>
      <Icon iconType="error" size="24p" skin="error" alt="" />
      <Visible xs sm>
        <Typography marginLeft="between-icon-and-text" fontSkin="body-small-bold" textColor="error">
          {message}
        </Typography>
      </Visible>
      <Hidden xs sm>
        <Typography
          marginLeft="between-icon-and-text"
          fontSkin="body-standard-bold"
          textColor="error"
        >
          {message}
        </Typography>
      </Hidden>
    </Box>
  );
};
